import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { createStore } from '../../state/store';
import { getDefaultState } from '../../state/store/getDefaultState';
import { UserCustomWindow, UserContextType } from '../../user/user.types';
import { snakeToCamel } from '../../caseUtils';
import { USER_CURRENT_STATUS } from '../../../../shared/constants/userStatusConstants';
import { USER_ONBOARDING } from '../../../../shared/constants/userOnboardingConstants';

declare let window: UserCustomWindow;

/** Old accounts haven't firstName + lastName so we fallback on userName */
const getUserName = (firstName: string | null, userName: string) => {
  if (firstName) {
    return firstName;
  }
  if (userName) {
    return userName;
  }
  return '';
};

const getUserFromWindow = (): UserContextType['currentUser'] => {
  const currentUser: UserContextType['currentUser'] = window.current_user
    ? snakeToCamel(window.current_user)
    : {};

  return {
    ...currentUser,
    name: getUserName(currentUser.firstName, currentUser.userName),
    isExpired: currentUser.status === USER_CURRENT_STATUS.EXPIRED_FREE_TRIAL,
    isOnboardedOnWatchers:
      currentUser.wasOnboarded &&
      currentUser.wasOnboarded.includes(USER_ONBOARDING.SEE_WATCHERS_INBOX),
    isOnboardedOnHistory:
      currentUser.wasOnboarded &&
      currentUser.wasOnboarded.includes(USER_ONBOARDING.SEE_LAST_HISTORY_ITEM),
    isIcp:
      window.METIERS_IS_ICP &&
      !!currentUser.metier &&
      window.METIERS_IS_ICP.includes(currentUser.metier),
  };
};

export const ReduxProviders: FC = ({ children }) => {
  const history = createBrowserHistory();
  const user = getUserFromWindow();
  const globalInitialState = getDefaultState(window.location.search, {
    daysRemaining: user.daysRemaining,
    accessPremium: window.access_premium,
  });

  const globalStore = createStore(globalInitialState, history);

  return (
    <Provider store={globalStore}>
      <ConnectedRouter history={history}>{children}</ConnectedRouter>
    </Provider>
  );
};
